import React, { useCallback, useEffect, useState } from "react";

import { getAllArticles } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const Articles = () => {
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const openItem = (item) => {
    goTo(null, null, `${process.env.REACT_APP_FARM_URL}/article/${item.link}`, true);
  };

  const loadAllArticles = useCallback(() => {
    getAllArticles({
      signal,
    })
      .then((res) => {
        setArticles(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllArticles();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${articles.length} articles`}
        description="View, update or add new articles here."
        extra={
          <Button size="small" type="secondary" href="/article/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={articles}
            config={{
              exclude: ["content", "summary", "image", "link", "utc", "date", "lastYear", "totalViews", "methods", "modules"],
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/article/update/",
                  tooltip: "Edit this article",
                },
                {
                  icon: "tabler/eye",
                  func: openItem,
                  tooltip: "View this article",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
